import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";

@Component({
    selector: "app-po-details",
    templateUrl: "./po-details.component.html",
    styleUrls: ["./po-details.component.scss"],
})
export class PoDetailsComponent implements OnInit {
    po: any;
    responseData: any;
    isError: any;
    isEmpty = false;
    displayName: any;
    sessionExpired = false;
    errorMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    poPaymentTermExist = false;
    validityExist = false;
    deliveryDateExist = false;
    lineItems: any;

    getPo(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/fetchPo",
            data
        );
    }

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private authService: AuthService,
        private posService: PosService
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        const userData = {
            poNumber: this.route.snapshot.params["poNo"],
            action: "get",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPo(userData).subscribe(
            (res) => {
                this.responseData = res;

                let sortedLineItems = this.responseData.pos[0].line_items.sort(
                    (a, b) => (a.po_item_line > b.po_item_line ? 1 : -1)
                );

                this.lineItems = sortedLineItems;

                if (
                    typeof this.responseData.pos[0].po_payment_term !==
                    "undefined"
                ) {
                    this.poPaymentTermExist = true;
                }

                if (
                    typeof this.responseData.pos[0].validity_end_date !==
                    "undefined"
                ) {
                    this.validityExist = true;
                }

                if (
                    typeof this.responseData.pos[0].line_items[0]
                        .item_delivery_date !== "undefined"
                ) {
                    this.deliveryDateExist = true;
                }
            },
            (error) => {}
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }
}
